import React, { Component } from 'react';
import {URL_IMG} from '../../configs/urlConfigs';
import { LBL_CREW_REQUESTED, LBL_CREW_ACCEPTED, LBL_CREW_REJECTED, LBL_CREW_ACCEPT, LBL_CREW_REJECT, LBL_CREW_CHECKIN, LBL_CREW_CHECKOUT, LBL_CREW_COMPLETED, LBL_CREW_CANCELLED,LBL_CREW_NOT_CHECKED_IN,LBL_CREW_ABSENT } from '../../configs/labelConfigs';
import { CREW_MAX_RATING, ENUM_SCHEDULE_CREW_STATUS,RANDOM_COLORS } from '../../configs/staticConfigs'; 
import { Link } from 'react-router-dom';
//import {getUserTimeZone} from '../../utils/userGroupUrlCheck';

class CrewCardComponent extends Component {
    
    constructor(props){
        super()
        this.state = {          
            rand :Math.floor(Math.random()*RANDOM_COLORS.length)
        }
    } 

    acceptRejectSchedule = (e,shiftId,profileId,status) => {
        e.preventDefault(); 
        this.props.crewAcceptRejectRequest(shiftId,profileId,status); 
    }

    crewCheckInOut = (e,shiftId,profileId,actionType) => {
        e.preventDefault(); 
        // SEND UTC TIME ONLY 
        let timeZoneOffSet = '+00'; 
        let timeVar = new Date(); 
        let yy = timeVar.getUTCFullYear(); 
        let mm = timeVar.getUTCMonth()+1;
        if(Number(mm) < 10) mm = '0'+mm;
        let dd = timeVar.getUTCDate();
        if(Number(dd) < 10) dd = '0'+dd;
        let hh = timeVar.getUTCHours();
        if(Number(hh) < 10) hh = '0'+hh;
        let ii = timeVar.getUTCMinutes();
        if(Number(ii) < 10) ii = '0'+ii;
        let ss = timeVar.getUTCSeconds();
        if(Number(ss) < 10) ss = '0'+ss;

        let dateTime = yy+'-'+mm+'-'+dd+'T'+hh+':'+ii+':'+ss+timeZoneOffSet; 
        if(actionType==='checkin') {
            this.props.crewCheckInRequest(shiftId,profileId,dateTime); 
        }
        else if(actionType==='checkout') {
            this.props.crewCheckOutRequest(shiftId,profileId,dateTime);
        }   
    }

    crewRemove = (e,schedule_shift_id,related_shifts,current_shift,crew_name) => {
        e.preventDefault();
        this.props.setScheduleId(schedule_shift_id,related_shifts,current_shift,crew_name); 
        // this.setState({schedule_shift_id:schedule_shift_id}, () => this.props.openConfirmModal());
    }

    onRadioChange = () => { 

    }
    


    render(){ 
        const { rand } = this.state; 
        let imgUserRemove = require('../../'+URL_IMG+'icon-user-remove.png');
        
        let activeShiftSkillCrewData = this.props.activeShiftSkillCrewData;

        const isSuperAdmin = this.props.isSuperAdmin ? this.props.isSuperAdmin : false; 
        
        // let activeShiftSkillId = this.props.activeShiftSkillId;
        // let activeShiftSkillName = this.props.activeShiftSkillName;

        let requested_count = 0; 
        let accepted_count  = 0; 
        let completed_count = 0; 
        let rejected_count  = 0; 
        let cancelled_count = 0; 
        let not_checked_in_count = 0; 
        let absent_count = 0; 

        let arrRequested    = []; 
        let arrAccepted     = []; 
        let arrCompleted    = [];
        let arrRejected     = []; 
        let arrCancelled    = []; 
        let arrNotCheckedin = [];  
        let arrAbsent       = [];  

        if(activeShiftSkillCrewData.hasOwnProperty('requested_count')) requested_count  = activeShiftSkillCrewData.requested_count; 
        if(activeShiftSkillCrewData.hasOwnProperty('accepted_count'))  accepted_count   = activeShiftSkillCrewData.accepted_count; 
        if(activeShiftSkillCrewData.hasOwnProperty('completed_count')) completed_count  = activeShiftSkillCrewData.completed_count; 
        if(activeShiftSkillCrewData.hasOwnProperty('rejected_count'))  rejected_count   = activeShiftSkillCrewData.rejected_count;  
        if(activeShiftSkillCrewData.hasOwnProperty('cancelled_count'))  cancelled_count = activeShiftSkillCrewData.cancelled_count; 
        if(activeShiftSkillCrewData.hasOwnProperty('not_checked_in_count'))  not_checked_in_count = activeShiftSkillCrewData.not_checked_in_count; 
        if(activeShiftSkillCrewData.hasOwnProperty('absent_count'))  absent_count = activeShiftSkillCrewData.absent_count; 

        if(activeShiftSkillCrewData.hasOwnProperty('requested')) arrRequested   = activeShiftSkillCrewData.requested; 
        if(activeShiftSkillCrewData.hasOwnProperty('accepted'))  arrAccepted    = activeShiftSkillCrewData.accepted; 
        if(activeShiftSkillCrewData.hasOwnProperty('completed')) arrCompleted   = activeShiftSkillCrewData.completed; 
        if(activeShiftSkillCrewData.hasOwnProperty('rejected'))  arrRejected    = activeShiftSkillCrewData.rejected;   
        if(activeShiftSkillCrewData.hasOwnProperty('cancelled'))  arrCancelled   = activeShiftSkillCrewData.cancelled;  
        if(activeShiftSkillCrewData.hasOwnProperty('not_checked_in'))  arrNotCheckedin   = activeShiftSkillCrewData.not_checked_in;  
        if(activeShiftSkillCrewData.hasOwnProperty('absent'))  arrAbsent   = activeShiftSkillCrewData.absent;  
        

        let shiftId = this.props.shiftId; 

        return(
            <>   
            <div>&nbsp;<br></br></div>
            {/* crewAcceptRejectRequest crewCheckInRequest crewCheckOutRequest  */}
            <div className="divHorizontalScroll">
            <div className="crewList">
                <div className="crewDetHeader th">{LBL_CREW_REQUESTED} ({requested_count})</div>
                { arrRequested.length > 0 && arrRequested.map((item,index) => 
                    {       
                    //let crewPoints          = item.hasOwnProperty('omnu_points') ? item.omnu_points : 0; 
                    let crewRatings         = item.hasOwnProperty('crew_total_rating') ? item.crew_total_rating : 0; 
                    //let scheduleShiftId     = item.hasOwnProperty('schedule_shift_id') ? item.schedule_shift_id : 0; 
                    let crewScheduleStatus  = item.hasOwnProperty('schedule_status') ? item.schedule_status : 0; 
                    let crewCheckedIn = 0;
                    if(Number(crewScheduleStatus)===Number(ENUM_SCHEDULE_CREW_STATUS.ON_GOING)) crewCheckedIn = 1;
                    let pointClass = 'crew__badge'; 
                    let ratingClass = 'crew__rating inputNum60 rating-display-only'; 
                    let imageClass = item.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';
                    let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name}/>;                                   

                    if ((item.crew_profile_picture) && item.crew_profile_picture.trim().length > 0){
                        profileImgTag = <img className={imageClass} src={item.crew_profile_picture} alt={item.crew_name} title={item.crew_name} />;
                    }
                    else if(((!item.crew_profile_picture) || item.crew_profile_picture.trim().length===0) && item.avatar_name && item.avatar_name.trim().length > 0) {
                        pointClass = 'crew__badge'; 
                        ratingClass = 'crew__rating inputNum60 padding-top-10 rating-display-only'; 
                        profileImgTag = <div title={item.crew_name} className={item.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:item.profile_color,borderColor:item.profile_color}}>{item.avatar_name}</div>; 
                    }

                    const chiefIcon = item.is_crew_chief?<div className="divFloatLeft" > <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span> </div>:'';

                    let department = item.department.length>0?item.department.map(e => e.name).join(",\r"):''
                    return(
                        <div key={'div_'+index} className="box">
                            <div className="crew">
                                <div className="crew__aside">
                                    <div className="crew__thumb">
                                        {profileImgTag}
                                    </div>
                                    {item.omnu_points >= 0 && <span className={pointClass}>{item.omnu_points}</span>}
                                <div className={ratingClass}>
                                        {CREW_MAX_RATING.map(ratingNum => {
                                            if(Number(ratingNum) <= Number(crewRatings)) {
                                                return(
                                                    <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                                )
                                            }else {                                           
                                                if(parseFloat(ratingNum)-0.5===parseFloat(crewRatings)){
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                    )
                                                }else{
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                    )
                                                }
                                            }
                                        })}
                                    </div>
                                </div>  
                                <div className="crew__content">
                                    <div className="crew__desc">
                                        {chiefIcon} {item.vehicle_added && <span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span>}<div>
                                            <h3 className="worWrapBreakWord">
                                                {item.crew_name}
                                                <p className="mb-0"><small>{item.pay_level_name}</small></p>
                                                <div className="row-dept text11 text-muted">{department}</div>
                                            </h3>
                                        </div>  
                                        {item.skill.skill_name && item.skill.skill_name.length > 0 && 
                                            <h6><small className="worWrapBreakWord"><i className={'fas '+item.skill.skill_icon}></i> {item.skill.skill_name}</small></h6> }
                                        <div className="padding-top-10">
                                            <h6><small>
                                                { !isSuperAdmin && this.props.hideAcceptRejectRemoveSchedule!=='yes' && <> 
                                                <Link to="#" className="textUl"><span onClick={(e) => this.acceptRejectSchedule(e,shiftId,item.crew_id,ENUM_SCHEDULE_CREW_STATUS.ACCEPTED)} >{LBL_CREW_ACCEPT}</span></Link> &nbsp;  &nbsp;
                                                <Link to="#" className="textUl text-red"><span onClick={(e) => this.acceptRejectSchedule(e,shiftId,item.crew_id,ENUM_SCHEDULE_CREW_STATUS.REJECTED)} >{LBL_CREW_REJECT}</span></Link> 
                                                </> }
                                            </small></h6>
                                        </div>
                                    </div>  
                                </div> 
                                {!isSuperAdmin && this.props.hideAcceptRejectRemoveSchedule!=='yes' && <div className="crew__button">
                                    <button onClick={(e) => this.crewRemove(e,item.schedule_shift_id,item.related_shifts,item.current_shift,item.crew_name)}><img src={imgUserRemove} alt='crew-remove' /></button>
                                </div>}
                            </div>
                        
                        </div>)
                    }) }
            </div>





            <div className="crewList">
                <div className="crewDetHeader th">{LBL_CREW_ACCEPTED} ({accepted_count})</div>
                
                { arrAccepted.length > 0 && arrAccepted.map((item,index) => 
                    {
                    // imgCrewProfile = require('../../'+URL_IMG+'crew-icon.jpg');
                    // if(item.crew_profile_picture.trim().length)  imgCrewProfile =  require('../../'+URL_IMG+'crew-icon.jpg'); 
                    //let crewPoints          = item.hasOwnProperty('omnu_points') ? item.omnu_points : 0; 
                    let crewRatings         = item.hasOwnProperty('crew_total_rating') ? item.crew_total_rating : 0; 
                    //let scheduleShiftId     = item.hasOwnProperty('schedule_shift_id') ? item.schedule_shift_id : 0; 
                    let crewScheduleStatus  = item.hasOwnProperty('schedule_status') ? item.schedule_status : 0; 
                    let crewCheckedIn = 0;
                    if(Number(crewScheduleStatus)===Number(ENUM_SCHEDULE_CREW_STATUS.ON_GOING)) crewCheckedIn = 1;
                    let pointClass = 'crew__badge'; 
                    let ratingClass = 'crew__rating inputNum60 rating-display-only';                    
                    let imageClass = item.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                    let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />; 

                    if ((item.crew_profile_picture) && item.crew_profile_picture.trim().length > 0){
                        profileImgTag = <img className={imageClass} src={item.crew_profile_picture} alt={item.crew_name} title={item.crew_name} />;
                    }
                    else if(((!item.crew_profile_picture) || item.crew_profile_picture.trim().length===0) && item.avatar_name && item.avatar_name.trim().length > 0) {
                        pointClass = 'crew__badge'; 
                        ratingClass = 'crew__rating inputNum60 padding-top-10 rating-display-only'; 
                        profileImgTag = <div title={item.crew_name} className={item.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:item.profile_color,borderColor:item.profile_color}}>{item.avatar_name}</div>; 
                    }

                    const chiefIcon = item.is_crew_chief?<div className="divFloatLeft" > <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span></div>:'';
                    let department = item.department.length>0?item.department.map(e => e.name).join(",\r"):''
                    return(
                    <div key={'cl-'+index} className="box py-2">
                        <div className="crew">
                            <div className="crew__aside">
                                <div className="crew__thumb">
                                    {profileImgTag}
                                </div>
                                {item.omnu_points >= 0 && <span className={pointClass}>{item.omnu_points}</span>}
                                <div className={ratingClass}>
                                    {CREW_MAX_RATING.map(ratingNum => {
                                       if(Number(ratingNum) <= Number(crewRatings)) {
                                        return(
                                            <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                        )
                                        }else {                                           
                                            if(parseFloat(ratingNum)-0.5===parseFloat(crewRatings)){
                                                return(
                                                    <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                )
                                            }else{
                                                return(
                                                    <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                )
                                            }
                                        }
                                    })}
                                </div>
                                <div className="d-flex align-items-center">
                                {item.vehicle_added && <div className="divFloatLeft" ><span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span></div>}
                                    {item.drive_to_shift_location&& <i class="fas fa-solid fa-id-card "></i>}
                                </div>
                            </div> 
                            <div className="crew__content">
                                <div className="crew__desc">
                                    {chiefIcon}<div><h3 className="worWrapBreakWord">{item.crew_name}<p className="mb-0"><small>{item.pay_level_name}</small></p><div className="row-dept text11 text-muted">{department}</div></h3></div>  
                                    {/* <h6><small className="worWrapBreakWord">{activeShiftSkillName}</small></h6> */}
                                    {item.skill.skill_name && item.skill.skill_name.length > 0 && 
                                            <h6><small className="worWrapBreakWord"><i className={'fas '+item.skill.skill_icon}></i> {item.skill.skill_name}</small></h6> }
                                    <div className="padding-top-10">
                                        <h6><small>
                                            {crewCheckedIn===0 && !isSuperAdmin && this.props.hideAcceptRejectRemoveSchedule!=='yes' && <Link to="#" className="textUl"><span onClick={(e) => this.crewCheckInOut(e,shiftId,item.crew_id,'checkin')} >{LBL_CREW_CHECKIN}</span></Link>} &nbsp;  &nbsp;
                                            {crewCheckedIn > 0 && !isSuperAdmin && this.props.hideAcceptRejectRemoveSchedule!=='yes' && <Link to="#" className="textUl text-red"><span onClick={(e) => this.crewCheckInOut(e,shiftId,item.crew_id,'checkout')} >{LBL_CREW_CHECKOUT}</span></Link> }
                                        </small></h6>
                                    </div>
                                </div>  
                            </div>
                            {!isSuperAdmin && this.props.hideAcceptRejectRemoveSchedule!=='yes' && <div className="crew__button">
                                 <button onClick={(e) => this.crewRemove(e,item.schedule_shift_id,item.related_shifts,item.current_shift,item.crew_name)}><img src={imgUserRemove} alt="crew-remove" /></button>
                            </div>}
                        </div>
                    </div>)
                }) }
                
            </div>


            <div className="crewList">
                <div className="crewDetHeader th">{LBL_CREW_COMPLETED} ({completed_count})</div>
                { arrCompleted.length===0 &&<div className="box">
                    <div className="maxHeight125">&nbsp;</div>
                </div>}
                { arrCompleted.length > 0 && arrCompleted.map((item,index) => 
                    {
                    //let crewPoints          = item.hasOwnProperty('omnu_points') ? item.omnu_points : 0; 
                    let crewRatings         = item.hasOwnProperty('crew_total_rating') ? item.crew_total_rating : 0; 
                    //let scheduleShiftId     = item.hasOwnProperty('schedule_shift_id') ? item.schedule_shift_id : 0; 
                    let crewScheduleStatus  = item.hasOwnProperty('schedule_status') ? item.schedule_status : 0; 
                    let crewCheckedIn = 0;
                    if(Number(crewScheduleStatus)===Number(ENUM_SCHEDULE_CREW_STATUS.ON_GOING)) crewCheckedIn = 1;
                    let pointClass = 'crew__badge'; 
                    let ratingClass = 'crew__rating inputNum60 rating-display-only';                    
                    let imageClass = item.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                    let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />; 
                    
                    // let profileImgTag = <img className="img-fluid img-chief img-prof-small" src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />; 

                    if ((item.crew_profile_picture) && item.crew_profile_picture.trim().length > 0){
                        profileImgTag = <img className={imageClass} src={item.crew_profile_picture} alt={item.crew_name} title={item.crew_name} />;
                    }
                    else if(((!item.crew_profile_picture) || item.crew_profile_picture.trim().length===0) && item.avatar_name && item.avatar_name.trim().length > 0) {
                        pointClass = 'crew__badge'; 
                        ratingClass = 'crew__rating inputNum60 padding-top-10 rating-display-only'; 
                        profileImgTag = <div title={item.crew_name} className={item.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:item.profile_color,borderColor:item.profile_color}}>{item.avatar_name}</div>; 
                    }

                    const chiefIcon = item.is_crew_chief?<div className="divFloatLeft" > <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span></div>:'';
                    let department = item.department.length>0?item.department.map(e => e.name).join(",\r"):''
                    return(
                    <div key={'completed-'+index} className="box">
                        <div className="crew">
                            <div className="crew__aside">
                                <div className="crew__thumb">
                                    {profileImgTag}
                                </div>
                                {item.omnu_points >= 0 && <span className={pointClass}>{item.omnu_points}</span>}
                                <div className={ratingClass}>
                                    {CREW_MAX_RATING.map(ratingNum => {
                                        if(Number(ratingNum) <= Number(crewRatings)) {
                                            return(
                                                <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                            )
                                        }else {                                           
                                            if(parseFloat(ratingNum)-0.5===parseFloat(crewRatings)){
                                                return(
                                                    <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                )
                                            }else{
                                                return(
                                                    <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                )
                                            }
                                        }
                                    })}
                                </div>
                            </div>
                            <div className="crew__content">
                                <div className="crew__desc">
                                    {chiefIcon}<div><h3 className="worWrapBreakWord">{item.crew_name}<p className="mb-0"><small>{item.pay_level_name}</small></p><div className="row-dept text11 text-muted">{department}</div></h3></div>  
                                    {item.skill.skill_name && item.skill.skill_name.length > 0 && 
                                        <h6><small className="worWrapBreakWord"><i className={'fas '+item.skill.skill_icon}></i> {item.skill.skill_name}</small></h6> }
                                    <div className="padding-top-10">
                                        <h6><small>&nbsp;
                                        </small></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
                }) }

                {not_checked_in_count > 0 && <div className="crewDetHeader th">{LBL_CREW_NOT_CHECKED_IN} ({not_checked_in_count})</div>}
                
                {arrNotCheckedin.length > 0 && arrNotCheckedin.map((item,index) => 
                    {
                    //let crewPoints          = item.hasOwnProperty('omnu_points') ? item.omnu_points : 0; 
                    let crewRatings         = item.hasOwnProperty('crew_total_rating') ? item.crew_total_rating : 0; 
                    //let scheduleShiftId     = item.hasOwnProperty('schedule_shift_id') ? item.schedule_shift_id : 0; 
                    let crewScheduleStatus  = item.hasOwnProperty('schedule_status') ? item.schedule_status : 0; 
                    let crewCheckedIn = 0;
                    if(Number(crewScheduleStatus)===Number(ENUM_SCHEDULE_CREW_STATUS.ON_GOING)) crewCheckedIn = 1;
                    let pointClass = 'crew__badge'; 
                    let ratingClass = 'crew__rating inputNum60 rating-display-only';                    
                    let imageClass = item.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                    let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />; 

                    if ((item.crew_profile_picture) && item.crew_profile_picture.trim().length > 0){
                        profileImgTag = <img className={imageClass} src={item.crew_profile_picture} alt={item.crew_name} title={item.crew_name} />;
                    }
                    else if(((!item.crew_profile_picture) || item.crew_profile_picture.trim().length===0) && item.avatar_name && item.avatar_name.trim().length > 0) {
                        pointClass = 'crew__badge'; 
                        ratingClass = 'crew__rating inputNum60 padding-top-10 rating-display-only'; 
                        profileImgTag = <div title={item.crew_name} className={item.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:item.profile_color,borderColor:item.profile_color}}>{item.avatar_name}</div>; 
                    }

                    const chiefIcon = item.is_crew_chief?<div className="divFloatLeft" > <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span></div>:'';
                    let department = item.department.length>0?item.department.map(e => e.name).join(",\r"):''
                    return(
                    <div key={'not_checkedin-'+index} className="box">
                        <div className="crew">
                            <div className="crew__aside">
                                <div className="crew__thumb">
                                    {profileImgTag}
                                </div>
                                {item.omnu_points >= 0 && <span className={pointClass}>{item.omnu_points}</span>}
                                <div className={ratingClass}>
                                    {CREW_MAX_RATING.map(ratingNum => {
                                        if(Number(ratingNum) <= Number(crewRatings)) {
                                            return(
                                                <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                            )
                                            }else {                                           
                                                if(parseFloat(ratingNum)-0.5===parseFloat(crewRatings)){
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                    )
                                                }else{
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                    )
                                                }
                                            }
                                    })}
                                </div>
                            </div>
                            <div className="crew__content">
                                <div className="crew__desc">
                                    {chiefIcon}<div><h3 className="worWrapBreakWord">{item.crew_name}<p className="mb-0"><small>{item.pay_level_name}</small></p><div className="row-dept text11 text-muted">{department}</div></h3></div>  
                                    {item.skill.skill_name && item.skill.skill_name.length > 0 && 
                                            <h6><small className="worWrapBreakWord"><i className={'fas '+item.skill.skill_icon}></i> {item.skill.skill_name}</small></h6> }
                                    <div className="padding-top-10">
                                        <h6><small>&nbsp;
                                        </small></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
                }) }


            </div>
            






            

            <div className="crewList">
                <div className="crewDetHeader th">{LBL_CREW_REJECTED} ({rejected_count})</div>
                
                { arrRejected.length===0 &&<div className="box">
                    <div className="maxHeight125">&nbsp;</div>
                </div>}

                { arrRejected.length > 0 && arrRejected.map((item,index) => 
                    {
                    //let crewPoints          = item.hasOwnProperty('omnu_points') ? item.omnu_points : 0; 
                    let crewRatings         = item.hasOwnProperty('crew_total_rating') ? item.crew_total_rating : 0; 
                    //let scheduleShiftId     = item.hasOwnProperty('schedule_shift_id') ? item.schedule_shift_id : 0; 
                    let crewScheduleStatus  = item.hasOwnProperty('schedule_status') ? item.schedule_status : 0; 
                    let crewCheckedIn = 0;
                    if(Number(crewScheduleStatus)===Number(ENUM_SCHEDULE_CREW_STATUS.ON_GOING)) crewCheckedIn = 1;
                    let pointClass = 'crew__badge'; 
                    let ratingClass = 'crew__rating inputNum60 rating-display-only';                    
                    let imageClass = item.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                    let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />; 
                    
                    // let profileImgTag = <img className="img-fluid img-chief img-prof-small" src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />; 

                    if ((item.crew_profile_picture) && item.crew_profile_picture.trim().length > 0){
                        profileImgTag = <img className={imageClass} src={item.crew_profile_picture} alt={item.crew_name} title={item.crew_name} />;
                    }
                    else if(((!item.crew_profile_picture) || item.crew_profile_picture.trim().length===0) && item.avatar_name && item.avatar_name.trim().length > 0) {
                        pointClass = 'crew__badge'; 
                        ratingClass = 'crew__rating inputNum60 padding-top-10 rating-display-only'; 
                        profileImgTag = <div title={item.crew_name} className={item.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:item.profile_color,borderColor:item.profile_color}}>{item.avatar_name}</div>; 
                    }

                    const chiefIcon = item.is_crew_chief?<div className="divFloatLeft" > <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span></div>:'';
                    let department = item.department.length>0?item.department.map(e => e.name).join(",\r"):''
                    return(
                    <div key={'rejected-'+index} className="box">
                        <div className="crew">
                            <div className="crew__aside">
                                <div className="crew__thumb">
                                    {profileImgTag}
                                </div>
                                {item.omnu_points >= 0 && <span className={pointClass}>{item.omnu_points}</span>}
                                <div className={ratingClass}>
                                    {CREW_MAX_RATING.map(ratingNum => {
                                        if(Number(ratingNum) <= Number(crewRatings)) {
                                            return(
                                                <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                            )
                                            }else {                                           
                                                if(parseFloat(ratingNum)-0.5===parseFloat(crewRatings)){
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                    )
                                                }else{
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                    )
                                                }
                                            }
                                    })}
                                </div>
                            </div>
                            <div className="crew__content">
                                <div className="crew__desc">
                                    {chiefIcon}<div><h3 className="worWrapBreakWord">{item.crew_name}<p className="mb-0"><small>{item.pay_level_name}</small></p><div className="row-dept text11 text-muted">{department}</div></h3></div>  
                                    {item.skill.skill_name && item.skill.skill_name.length > 0 && 
                                        <h6><small className="worWrapBreakWord"><i className={'fas '+item.skill.skill_icon}></i> {item.skill.skill_name}</small></h6> }
                                    <div className="padding-top-10">
                                        <h6><small>&nbsp;
                                        </small></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
                }) } 


                {cancelled_count > 0 && <div className="crewDetHeader th">{LBL_CREW_CANCELLED} ({cancelled_count})</div>}
                
                {arrCancelled.length > 0 && arrCancelled.map((item,index) => 
                    {
                    //let crewPoints          = item.hasOwnProperty('omnu_points') ? item.omnu_points : 0; 
                    let crewRatings         = item.hasOwnProperty('crew_total_rating') ? item.crew_total_rating : 0; 
                    //let scheduleShiftId     = item.hasOwnProperty('schedule_shift_id') ? item.schedule_shift_id : 0; 
                    let crewScheduleStatus  = item.hasOwnProperty('schedule_status') ? item.schedule_status : 0; 
                    let crewCheckedIn = 0;
                    if(Number(crewScheduleStatus)===Number(ENUM_SCHEDULE_CREW_STATUS.ON_GOING)) crewCheckedIn = 1;
                    let pointClass = 'crew__badge'; 
                    let ratingClass = 'crew__rating inputNum60 rating-display-only';                    
                    let imageClass = item.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                    let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />; 

                    if ((item.crew_profile_picture) && item.crew_profile_picture.trim().length > 0){
                        profileImgTag = <img className={imageClass} src={item.crew_profile_picture} alt={item.crew_name} title={item.crew_name} />;
                    }
                    else if(((!item.crew_profile_picture) || item.crew_profile_picture.trim().length===0) && item.avatar_name && item.avatar_name.trim().length > 0) {
                        pointClass = 'crew__badge'; 
                        ratingClass = 'crew__rating inputNum60 padding-top-10 rating-display-only'; 
                        profileImgTag = <div title={item.crew_name} className={item.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:item.profile_color,borderColor:item.profile_color}}>{item.avatar_name}</div>; 
                    }

                    const chiefIcon = item.is_crew_chief?<div className="divFloatLeft" > <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span></div>:'';
                    let department = item.department.length>0?item.department.map(e => e.name).join(",\r"):''
                    return(
                    <div key={'cancelled-'+index} className="box">
                        <div className="crew">
                            <div className="crew__aside">
                                <div className="crew__thumb">
                                    {profileImgTag}
                                </div>
                                {item.omnu_points >= 0 && <span className={pointClass}>{item.omnu_points}</span>}
                                <div className={ratingClass}>
                                    {CREW_MAX_RATING.map(ratingNum => {
                                        if(Number(ratingNum) <= Number(crewRatings)) {
                                            return(
                                                <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                            )
                                            }else {                                           
                                                if(parseFloat(ratingNum)-0.5===parseFloat(crewRatings)){
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                    )
                                                }else{
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                    )
                                                }
                                            }
                                    })}
                                </div>
                            </div>
                            <div className="crew__content">
                                <div className="crew__desc">
                                    {chiefIcon}<div><h3 className="worWrapBreakWord">{item.crew_name}<p className="mb-0"><small>{item.pay_level_name}</small></p><div className="row-dept text11 text-muted">{department}</div></h3></div>  
                                    {item.skill.skill_name && item.skill.skill_name.length > 0 && 
                                            <h6><small className="worWrapBreakWord"><i className={'fas '+item.skill.skill_icon}></i> {item.skill.skill_name} </small></h6> }
                                    <div className="padding-top-10">
                                        <h6><small>&nbsp;
                                        </small></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
                }) }

                {absent_count > 0 && <div className="crewDetHeader th">{LBL_CREW_ABSENT} ({absent_count})</div>}
                
                {arrAbsent.length > 0 && arrAbsent.map((item,index) => 
                    {
                    //let crewPoints          = item.hasOwnProperty('omnu_points') ? item.omnu_points : 0; 
                    let crewRatings         = item.hasOwnProperty('crew_total_rating') ? item.crew_total_rating : 0; 
                    //let scheduleShiftId     = item.hasOwnProperty('schedule_shift_id') ? item.schedule_shift_id : 0; 
                    let crewScheduleStatus  = item.hasOwnProperty('schedule_status') ? item.schedule_status : 0; 
                    let crewCheckedIn = 0;
                    if(Number(crewScheduleStatus)===Number(ENUM_SCHEDULE_CREW_STATUS.ON_GOING)) crewCheckedIn = 1;
                    let pointClass = 'crew__badge'; 
                    let ratingClass = 'crew__rating inputNum60 rating-display-only';                    
                    let imageClass = item.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                    let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />; 

                    if ((item.crew_profile_picture) && item.crew_profile_picture.trim().length > 0){
                        profileImgTag = <img className={imageClass} src={item.crew_profile_picture} alt={item.crew_name} title={item.crew_name} />;
                    }
                    else if(((!item.crew_profile_picture) || item.crew_profile_picture.trim().length===0) && item.avatar_name && item.avatar_name.trim().length > 0) {
                        pointClass = 'crew__badge'; 
                        ratingClass = 'crew__rating inputNum60 padding-top-10 rating-display-only'; 
                        profileImgTag = <div title={item.crew_name} className={item.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:item.profile_color,borderColor:item.profile_color}}>{item.avatar_name}</div>; 
                    }

                    const chiefIcon = item.is_crew_chief?<div className="divFloatLeft" > <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span></div>:'';
                    let department = item.department.length>0?item.department.map(e => e.name).join(",\r"):''
                    return(
                    <div key={'absent-'+index} className="box">
                        <div className="crew">
                            <div className="crew__aside">
                                <div className="crew__thumb">
                                    {profileImgTag}
                                </div>
                                {item.omnu_points >= 0 && <span className={pointClass}>{item.omnu_points}</span>}
                                <div className={ratingClass}>
                                    {CREW_MAX_RATING.map(ratingNum => {
                                        if(Number(ratingNum) <= Number(crewRatings)) {
                                            return(
                                                <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                            )
                                            }else {                                           
                                                if(parseFloat(ratingNum)-0.5===parseFloat(crewRatings)){
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                    )
                                                }else{
                                                    return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                    )
                                                }
                                            }
                                    })}
                                </div>
                            </div>
                            <div className="crew__content">
                                <div className="crew__desc">
                                    {chiefIcon}<div><h3 className="worWrapBreakWord">{item.crew_name}<p className="mb-0"><small>{item.pay_level_name}</small></p><div className="row-dept text11 text-muted">{department}</div></h3></div>  
                                    {item.skill.skill_name && item.skill.skill_name.length > 0 && 
                                            <h6><small className="worWrapBreakWord"><i className={'fas '+item.skill.skill_icon}></i> {item.skill.skill_name}</small></h6> }
                                    <div className="padding-top-10">
                                        <h6><small>&nbsp;
                                        </small></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
                }) }
                
            </div>



            </div>
            </>
        )
    }

}
export default CrewCardComponent;